import { useMemo } from "react";

import Fuse from "fuse.js";
import { useNavigate } from "react-router-dom";

import { SpotlightRoutingItem } from "./SpotlightRoutingItem";
import { useSpotlightSearchRoutes } from "./useSpotlightSearchRoutes";

const fuseOptions = {
    keys: ["name", "description"],
    threshold: 0.3,
    ignoreLocation: true,
    includeScore: true,
    shouldSort: true,
    minMatchCharLength: 2,
};

export const useGetRoutes = (onCallback: () => void) => {
    const routes = useSpotlightSearchRoutes();
    const fuse = useMemo(() => new Fuse(routes, fuseOptions), [routes]);
    const navigate = useNavigate();
    const getRoutes = (searchValue: string) => {
        if (!searchValue) {
            return [];
        }

        const searchResults = fuse.search(searchValue);
        if (searchResults.length === 0) {
            return [];
        }

        const options = searchResults.map(({ item }) => ({
            label: (
                <SpotlightRoutingItem
                    name={item.name}
                    description={item.description}
                    searchValue={searchValue}
                    route={item.route}
                    icon={item.icon}
                    onCallback={() => {
                        onCallback();
                        navigate(item.route);
                    }}
                />
            ),
            value: item.route,
        }));

        return [
            {
                label: "Routing",
                options,
            },
        ];
    };

    return {
        getRoutes,
    };
};
